// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-message-container {
  width: 100%;
  height: max-content;
  height: 82%;
  overflow: auto;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px; }
  .chat-message-container__box {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 20px 0;
    width: 80%;
    margin: auto; }
    .chat-message-container__box-avatar {
      height: 36px;
      width: 36px;
      min-width: 36px;
      border-radius: 50%;
      background-color: #2fa078;
      line-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: 500;
      text-transform: uppercase; }
    .chat-message-container__box.box-user {
      justify-content: flex-end; }
    .chat-message-container__box.box-admin {
      justify-content: flex-start; }
      .chat-message-container__box.box-admin .chat-message-container__box-avatar {
        background-color: #000; }
    .chat-message-container__box-content {
      height: max-content;
      min-height: 34px;
      width: max-content;
      border-radius: 8px;
      background-color: #d9d9d9;
      display: flex;
      align-items: center;
      color: #000;
      font-weight: 400;
      font-size: 16px;
      padding: 7px 12px;
      flex-wrap: wrap;
      white-space: break-spaces; }
  .chat-message-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5; }
  .chat-message-container::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5; }
  .chat-message-container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #adacac; }

.blinking-cursor {
  display: none;
  font-weight: 400;
  font-size: 15px;
  color: #2e3d48;
  animation: 0.8s blink step-end infinite; }

@keyframes blink {
  0% {
    opacity: 1; }
  50% {
    opacity: 0; }
  100% {
    opacity: 1; } }
`, "",{"version":3,"sources":["webpack://./src/features/Chatbot/Components/ChatMessage/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iFACmC,EAAA;EAEnC;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;IACV,YAAY,EAAA;IAEZ;MACE,YAAY;MACZ,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,gBAAgB;MAChB,yBAAyB,EAAA;IArB5B;MAyBG,yBAAyB,EAAA;IAzB5B;MA6BG,2BAA2B,EAAA;MA7B9B;QAgCK,sBAAsB,EAAA;IAI1B;MACE,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,eAAe;MACf,yBAAyB,EAAA;EAzD/B;IA8DI,oDAAoD;IACpD,mBAAmB;IACnB,yBAAyB,EAAA;EAhE7B;IAoEI,UAAU;IACV,yBAAyB,EAAA;EArE7B;IAyEI,mBAAmB;IACnB,oDAAoD;IACpD,yBAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;EAKd,uCAAuC,EAAA;;AAGzC;EACE;IACE,UAAU,EAAA;EAGZ;IACE,UAAU,EAAA;EAGZ;IACE,UAAU,EAAA,EAAA","sourcesContent":[".chat-message-container {\r\n  width: 100%;\r\n  height: max-content;\r\n  height: 82%;\r\n  overflow: auto;\r\n  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,\r\n    rgba(17, 17, 26, 0.1) 0px 0px 8px;\r\n\r\n  &__box {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    padding: 20px 0;\r\n    width: 80%;\r\n    margin: auto;\r\n\r\n    &-avatar {\r\n      height: 36px;\r\n      width: 36px;\r\n      min-width: 36px;\r\n      border-radius: 50%;\r\n      background-color: #2fa078;\r\n      line-height: 32px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      color: #fff;\r\n      font-weight: 500;\r\n      text-transform: uppercase;\r\n    }\r\n\r\n    &.box-user {\r\n      justify-content: flex-end;\r\n    }\r\n\r\n    &.box-admin {\r\n      justify-content: flex-start;\r\n\r\n      .chat-message-container__box-avatar {\r\n        background-color: #000;\r\n      }\r\n    }\r\n\r\n    &-content {\r\n      height: max-content;\r\n      min-height: 34px;\r\n      width: max-content;\r\n      border-radius: 8px;\r\n      background-color: #d9d9d9;\r\n      display: flex;\r\n      align-items: center;\r\n      color: #000;\r\n      font-weight: 400;\r\n      font-size: 16px;\r\n      padding: 7px 12px;\r\n      flex-wrap: wrap;\r\n      white-space: break-spaces;\r\n    }\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    border-radius: 10px;\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 8px;\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    background-color: #adacac;\r\n  }\r\n}\r\n\r\n.blinking-cursor {\r\n  display: none;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  color: #2e3d48;\r\n  -webkit-animation: 0.8s blink step-end infinite;\r\n  -moz-animation: 0.8s blink step-end infinite;\r\n  -ms-animation: 0.8s blink step-end infinite;\r\n  -o-animation: 0.8s blink step-end infinite;\r\n  animation: 0.8s blink step-end infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
